module.exports = __webpack_public_path__ + "58ff8fe20b4390834239ad8105389269.png";